import marked from 'marked';

const marked_ = marked;

export default {
	data() {
		return {
			marked: marked_
		}
	}
}